export default {
  CREATE_RSEE_PACKAGE_REQUEST_LOADING: 'CREATE_RSEE_PACKAGE_REQUEST_LOADING',
  CREATE_RSEE_PACKAGE_REQUEST_SUCCESS: 'CREATE_RSEE_PACKAGE_REQUEST_SUCCESS',
  CREATE_RSEE_PACKAGE_REQUEST_FAILED: 'CREATE_RSEE_PACKAGE_REQUEST_FAILED',
  CREATE_RSEE_PACKAGE_REQUEST_REJECT: 'CREATE_RSEE_PACKAGE_REQUEST_REJECT',

  UPDATE_RSEE_PACKAGE_REQUEST_LOADING: 'UPDATE_RSEE_PACKAGE_REQUEST_LOADING',
  UPDATE_RSEE_PACKAGE_REQUEST_SUCCESS: 'UPDATE_RSEE_PACKAGE_REQUEST_SUCCESS',
  UPDATE_RSEE_PACKAGE_REQUEST_FAILED: 'UPDATE_RSEE_PACKAGE_REQUEST_FAILED',
  UPDATE_RSEE_PACKAGE_REQUEST_REJECT: 'UPDATE_RSEE_PACKAGE_REQUEST_REJECT',

  GET_RSEE_PACKAGE_BY_ID_LOADING: 'GET_RSEE_PACKAGE_BY_ID_LOADING',
  GET_RSEE_PACKAGE_BY_ID_SUCCESS: 'GET_RSEE_PACKAGE_BY_ID_SUCCESS',
  GET_RSEE_PACKAGE_BY_ID_FAILED: 'GET_RSEE_PACKAGE_BY_ID_FAILED',
  GET_RSEE_PACKAGE_BY_ID_REJECT: 'GET_RSEE_PACKAGE_BY_ID_REJECT',

  GET_ALL_RSEE_PACKAGES_REQUESTS_LOADING: 'GET_ALL_RSEE_PACKAGES_REQUESTS_LOADING',
  GET_ALL_RSEE_PACKAGES_REQUESTS_SUCCESS: 'GET_ALL_RSEE_PACKAGES_REQUESTS_SUCCESS',
  GET_ALL_RSEE_PACKAGES_REQUESTS_FAILED: 'GET_ALL_RSEE_PACKAGES_REQUESTS_FAILED',
  GET_ALL_RSEE_PACKAGES_REQUESTS_REJECT: 'GET_ALL_RSEE_PACKAGES_REQUESTS_REJECT',

  GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_LOADING: 'GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_LOADING',
  GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_SUCCESS: 'GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_SUCCESS',
  GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_FAILED: 'GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_FAILED',
  GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_REJECT: 'GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_REJECT',

  UPDATE_RSEE_PACKAGE_STATUS_LOADING: 'UPDATE_RSEE_PACKAGE_STATUS_LOADING',
  UPDATE_RSEE_PACKAGE_STATUS_SUCCESS: 'UPDATE_RSEE_PACKAGE_STATUS_SUCCESS',
  UPDATE_RSEE_PACKAGE_STATUS_FAILED: 'UPDATE_RSEE_PACKAGE_STATUS_FAILED',
  UPDATE_RSEE_PACKAGE_STATUS_REJECT: 'UPDATE_RSEE_PACKAGE_STATUS_REJECT',
};